import React, { useState } from 'react';
import './DeleteIfInactiveOption.css';

// "No-commitment" sign-up, shown on the sign-up form for communities whose
// record has showNoCommitmentSignup: true (Admin → Manage Communities →
// Update): an unticked choice to have the account deleted in 3 months if no
// suggestion interests them — the same pending deletion the /meet chat
// offers (EmailConsentForm.js), cancelled the moment they say yes to someone.

// Reused on the quick-match hero's email step (QuickMatchHero.js) with
// what="details" (no account yet) and the community's retention months.
const DeleteIfInactiveOption = ({ checked, onChange, what = 'account', months = 3, className = '' }) => {
  const [showWhy, setShowWhy] = useState(false);

  return (
    <div className={`delete-if-inactive${className ? ` ${className}` : ''}`}>
      <div className="delete-if-inactive-title">No commitment <span className="delete-if-inactive-optional">(optional)</span></div>
      <label className="delete-if-inactive-label">
        <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
        <span>
          Automatically delete my {what} after {months} months if I receive no suggestions I&apos;m interested in.{' '}
          <button
            type="button"
            className="delete-if-inactive-why-btn"
            aria-expanded={showWhy}
            onClick={(e) => { e.preventDefault(); setShowWhy(!showWhy); }}
          >
            Why {months} months? {showWhy ? '▴' : '▾'}
          </button>
        </span>
      </label>
      {showWhy && (
        <ul className="delete-if-inactive-why" onClick={() => setShowWhy(false)} title="Tap to hide">
          <li>We suggest on quality, not quantity, only when there&apos;s a truly good fit.</li>
          <li>The group is new, and people are joining all the time.</li>
          <li>If someone who&apos;s a good fit joins, we&apos;ll let you know.</li>
          <li>Leave too soon (or don&apos;t join and give it a try) and you could miss them by a few weeks.</li>
        </ul>
      )}
    </div>
  );
};

export default DeleteIfInactiveOption;
